import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, semantic, space } from '../../theme/tokens';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[5]};
  width: 100%;
  flex: 1;
`;

export const BackRow = styled.div`
  position: relative;
  width: 100%;
  height: calc(${space[6]} + ${space[2]});

  & > button {
    left: 0;
  }
`;

export const Heading = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
  text-align: center;
  line-height: 1.25;
  margin: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
  }
`;

export const HeadingAccent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;

export const UpgradePrice = styled.p`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
  margin: 0;

  & strong {
    font-weight: ${fonts.weight.semiBold};
  }
`;

export const ActionsSlot = styled.div`
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-top: auto;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: ${space[3]};
`;
